import {Hydra} from '../generic/hydra';

import {DossierInterface} from './Dossier';
import {
    DossierRecevableRequest as DossierRecevableRequestBaseInterface
} from '../../interface/api/DossierRecevableRequest';

export type DossierRecevableRequestInterface = DossierRecevableRequestBaseInterface;

export class DossierRecevableRequest extends Hydra implements DossierRecevableRequestInterface {

    dossier?: DossierInterface | string | null;

    complement?: string | null;


    constructor(options: DossierRecevableRequestInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
